import { AuthStatusCode } from "@anydo/interfaces";
import { AnydoAuthError } from "@anydo/core";

export function createAnydoAuthErrorByStatus(status = 0, responseData?: unknown): AnydoAuthError {
  let message;

  switch (status) {
    case 0:
      message = getMessage(responseData, "Network is unavilable");
      return new AnydoAuthError(AuthStatusCode.NETWORK_UNAVAILABLE, message);
    case 400:
      message = getMessage(responseData, "Bad request");
      return new AnydoAuthError(getStatusByErrorCode(responseData), message);
    case 401:
      message = getMessage(responseData, "Unauthorized request");
      return new AnydoAuthError(AuthStatusCode.UNAUTHORIZED, message);
    case 403:
      message = getMessage(responseData, "Forbidden request");
      return new AnydoAuthError(AuthStatusCode.FORBIDDEN, message);
    case 409:
      message = getMessage(responseData, "User already exist");
      return new AnydoAuthError(AuthStatusCode.USER_ALREADY_EXIST, message);
    case 500:
      message = getMessage(responseData, "Server error");
      return new AnydoAuthError(AuthStatusCode.INTERNAL_SERVER_ERROR, message);
    default:
      if (process.env.NODE_ENV === "development") {
        throw new ReferenceError(`Auth#_createAnydoAuthErrorByStatus() no implementation to status of ${status}`);
      }
      message = getMessage(responseData, "An error has occurred");

      return new AnydoAuthError(AuthStatusCode.UNKNOWN_ERROR, message);
  }
}

enum AuthErrorCode {
  LAST_BOARD_ADMIN_REMOVAL = 10006,
  LAST_SPACE_ADMIN_REMOVAL = 10007,
  LAST_GROCERY_BOARD_MEMBER_REMOVAL = 10061,
  CANT_DELETE_PREMIUM_USER = 10049,
}

function getStatusByErrorCode(data: unknown) {
  const code = data != null && typeof data === "object" && "error_code" in data ? data.error_code : undefined;

  switch (code) {
    case AuthErrorCode.LAST_SPACE_ADMIN_REMOVAL:
      return AuthStatusCode.LAST_SPACE_ADMIN_REMOVAL;

    case AuthErrorCode.LAST_BOARD_ADMIN_REMOVAL:
      return AuthStatusCode.LAST_BOARD_ADMIN_REMOVAL;

    case AuthErrorCode.LAST_GROCERY_BOARD_MEMBER_REMOVAL:
      return AuthStatusCode.LAST_GROCERY_BOARD_MEMBER_REMOVAL;

    case AuthErrorCode.CANT_DELETE_PREMIUM_USER:
      return AuthStatusCode.CANT_DELETE_PREMIUM_USER;

    default:
      return AuthStatusCode.INVALID_PARAMATER;
  }
}

//#region Helps
function getMessage(responseData: any, defaultMessage: string): string {
  if (responseData != null && typeof responseData === "object" && "error_message" in responseData) {
    return responseData.error_message;
  }

  if (responseData != null && typeof responseData !== "string" && typeof responseData.Error === "string") {
    return responseData.Error;
  } else if (typeof responseData === "string") {
    return responseData;
  } else {
    return defaultMessage;
  }
}
//#endregion
